import { Map } from "ol";
import Feature from "ol/Feature";
import { Vector as VectorLayer } from "ol/layer";
import { Cluster } from "ol/source";
import { flattenMapLayers } from "~/utils/flattenMapLayers";

export function findFeatureById(map: Map, id: string): Feature | null {
  const layers = flattenMapLayers(map);
  if (!id) return null;

  for (let i = 0; i < layers.length; i++) {
    const l = layers[i];
    if (l instanceof VectorLayer) {
      const source = l.getSource();
      if (source instanceof Cluster) {
        const feat = source.getSource().getFeatureById(id);
        if (feat) return feat;
      } else {
        const feat = source.getFeatureById(id);
        if (feat) return feat;
      }
    }
  }
  return null;
}
